import apiClient, { USE_MOCK } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';
import { mockWishTreeData } from './mockWishTreeData';

/**
 * 發願樹 API Service
 * 比照 lampService.js 的 USE_MOCK 分支模式。
 */
const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * 取得目前已掛上樹的發願卡列表
 */
export const getWishList = async () => {
  await delay(300);
  return mockWishTreeData.wishList;
};

/**
 * 發願文字列表
 */
export const geContentList = async () => {
  return apiClient.get(ENDPOINTS.WISH_TREE.i165_CONTENT_LIST);
};

/**
 * 送出一則發願，掛上願心樹
 * POST /v1/exhibitionVow/record/add (exhibitionVow002)
 * @param {Object} params
 * @param {number} params.content_id - 發願文字 id（來自 content list 的 content_ind）
 * @param {string} params.vower_name - 發願者姓名
 * @param {number} params.image_id - 卡片圖案 id（1~4）
 */
export const addWish = async (params) => {
  if (USE_MOCK) {
    await delay(800);
    return {
      ...mockRecordAdd,
      content: matched?.content ?? mockRecordAdd.content,
      content_id: params.content_id,
      vower_name: params.vower_name,
      image_id: params.image_id,
      created_at: new Date().toUTCString(),
    };
  }

  return apiClient.post(ENDPOINTS.WISH_TREE.i166_RECORD_ADD, {
    content_id: params.content_id,
    vower_name: params.vower_name,
    image_id: params.image_id,
  });
};

/**
 * 描述發願（取得發願卡詳情）
 * POST /v1/exhibitionVow/record/describe (exhibitionVow003)
 * @param {Object} params
 * @param {number} [params.record_id] - 發願記錄 id（與 recency + image_id 擇一必填）
 * @param {number} [params.image_id] - 卡片圖案 id（1~4），需與 recency 同時傳入
 * @param {number} [params.recency] - 0.0~1.0，越小表示獲得的資料越新
 */
/** JSON 數字無法區分 1 與 1.0，整數 recency 強制寫成 x.0 */
const toFloatJson = (n) => {
  const f = parseFloat(n);
  return Number.isInteger(f) ? f.toFixed(1) : String(f);
};

export const postDescribeWish = async (params) => {
  if (params.record_id != null) {
    return apiClient.post(ENDPOINTS.WISH_TREE.i167_RECORD_DESCRIBE, {
      record_id: params.record_id,
    });
  }

  // 手動組 JSON，確保 recency 在 wire 上為 float（如 1.0 而非 1）
  const body = `{"image_id":${Number(params.image_id)},"recency":${toFloatJson(params.recency)}}`;
  return apiClient.post(ENDPOINTS.WISH_TREE.i167_RECORD_DESCRIBE, body);
};

/**
 * 取得發願總數
 * GET /v1/exhibitionVow/record/count (exhibitionVow004 / 171)
 * @returns {Promise<{message: string, result_code: number, total: number}>}
 */
export const getWishCount = async () => {
  if (USE_MOCK) {
    await delay(300);
    return { message: 'Success', result_code: 200, total: 56 };
  }

  return apiClient.get(ENDPOINTS.WISH_TREE.i171_RECORD_COUNT);
};

export default {
  getWishList,
  geContentList,
  addWish,
  postDescribeWish,
  getWishCount,
};
